<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Typografi
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Emmalagat använder <strong>Poppins</strong> för rubriker och UI-etiketter,
      och <strong>Plus Jakarta Sans</strong> för brödtext och beskrivningar.
    </p>

    <div class="mb-8">
      <p
        class="font-[Poppins] font-bold text-[11px] text-teal-500 tracking-[1.2px] uppercase mb-4"
      >
        Poppins — Rubriker & UI
      </p>
      <div
        v-for="t in poppinsScales"
        :key="t.label"
        class="flex items-baseline gap-5 pb-4 mb-4 border-b border-[#f0f2f4]"
      >
        <span
          class="font-[Poppins] font-bold text-[10px] text-[#a0b0ae] min-w-[80px]"
          >{{ t.label }}</span
        >
        <span
          class="font-[Poppins] text-[#191c1e] leading-[1.2]"
          :style="{
            fontWeight: t.weight,
            fontSize: t.size,
            letterSpacing: t.ls,
            textTransform: t.upper ? 'uppercase' : 'none',
          }"
          >Emmalagat</span
        >
        <span class="font-mono text-[11px] text-[#a0b0ae]"
          >{{ t.size }} / {{ t.weight }}</span
        >
      </div>
    </div>

    <div>
      <p
        class="font-[Poppins] font-bold text-[11px] text-teal-500 tracking-[1.2px] uppercase mb-4"
      >
        Plus Jakarta Sans — Brödtext & Meta
      </p>
      <div
        v-for="t in jakartaScales"
        :key="t.label"
        class="flex items-baseline gap-5 pb-3 mb-3 border-b border-[#f0f2f4]"
      >
        <span
          class="font-[Poppins] font-bold text-[10px] text-[#a0b0ae] min-w-[120px]"
          >{{ t.label }}</span
        >
        <span
          class="font-[Plus_Jakarta_Sans] text-[#3c4947] leading-[1.6]"
          :style="{ fontWeight: t.weight, fontSize: t.size }"
          >En hyllning till enkla råvaror och djärva smaker.</span
        >
        <span class="font-mono text-[11px] text-[#a0b0ae] whitespace-nowrap">{{
          t.size
        }}</span>
      </div>
    </div>
    <CodeBlock :code="code" />
  </div>
</template>

<script setup>
import CodeBlock from "../components/CodeBlock.vue";

const poppinsScales = [
  { label: "Display / Hero", size: "52px", weight: 900, ls: "-1.5px" },
  { label: "H1", size: "36px", weight: 900, ls: "-1px" },
  { label: "H2", size: "24px", weight: 700, ls: "-0.5px" },
  { label: "H3", size: "18px", weight: 700, ls: "0" },
  { label: "Etikett", size: "10px", weight: 700, ls: "1.2px", upper: true },
];
const jakartaScales = [
  { label: "Stor brödtext", size: "20px", weight: 400 },
  { label: "Brödtext", size: "16px", weight: 400 },
  { label: "Liten text", size: "14px", weight: 400 },
  { label: "Meta / Info", size: "12px", weight: 400 },
];

const code = `<!-- Rubriker använder Poppins -->
<h1 class="font-[Poppins] font-black text-[36px] text-[#191c1e] tracking-[-1px]">Rubrik H1</h1>
<h2 class="font-[Poppins] font-black text-[24px] text-[#191c1e] tracking-[-0.5px]">Rubrik H2</h2>
<h3 class="font-[Poppins] font-bold text-[18px] text-[#191c1e]">Rubrik H3</h3>

<!-- Brödtext använder Plus Jakarta Sans -->
<p class="font-[Plus_Jakarta_Sans] text-[16px] text-[#3c4947] leading-[1.65]">Brödtext</p>
<p class="font-[Plus_Jakarta_Sans] text-[14px] text-[#6c7a77]">Liten text / Meta</p>

<!-- Etikett (uppercase) -->
<span class="font-[Poppins] font-bold text-[10px] tracking-[1.2px] uppercase text-[#6c7a77]">
  ETIKETT
</span>`;
</script>
